module.exports = __webpack_public_path__ + "static/img/site4.5953a68.gif";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/site4.gif
// module id = tGeW
// module chunks = 1